/**
 * financiamento-page.js — Entry point da página financiamento.html
 */

import { initHeader }         from '../components/header.js';
import { initSmoothScroll }   from '../components/smooth-scroll.js';
import { applyConfiguracoes } from '../components/configuracoes.js';
import { initFinanciamento }  from '../components/financiamento.js';
import { renderFooter }       from '../components/footer.js';

document.addEventListener('DOMContentLoaded', () => {
  renderFooter();         // ← injeta footer antes de applyConfiguracoes
  initHeader();
  initSmoothScroll();
  applyConfiguracoes();
  initFinanciamento();
});
